import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './index.scss';

/* The order total and the two actions it drives, docked to the bottom of the
 * screen. It replaces the caption-sized total and the button row that used to
 * be repeated above and below the table: one place to look, one place to act,
 * and both stay put while the client works down a long order.
 *
 * Sticky rather than fixed on purpose - it stays in the flow, so the table
 * above it sizes itself to the space that is actually left. */
const CheckoutBar = ({ total = 0, itemsCount = 0, children }) => {
  const { t } = useTranslation('cart');

  return (
    <div className="checkout-bar">
      <div className="checkout-bar__actions">{children}</div>
      <div className="checkout-bar__figures">
        <span className="checkout-bar__count">
          {t('items-count')} <b>{itemsCount.toLocaleString()}</b>
        </span>
        <span className="checkout-bar__total">
          <span className="checkout-bar__label">{t('cart-total')}</span>
          {/* Amount and currency read left to right inside the RTL bar, the
              way the balance in the top bar already does. */}
          <span className="checkout-bar__amount" dir="ltr">
            {total.toLocaleString()}
          </span>
          <span className="checkout-bar__currency">{t('currency')}</span>
        </span>
      </div>
    </div>
  );
};

CheckoutBar.propTypes = {
  total: PropTypes.number,
  itemsCount: PropTypes.number,
  children: PropTypes.node,
};

export default CheckoutBar;
